import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const SaleHandoff = {
  Header: lazy(
    () => import('components/sale-handoff/components/SaleHandoffHeader')
  ),
  Content: lazy(
    () => import('components/sale-handoff/components/SaleHandoffContent')
  )
};

export default SaleHandoff;
